<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import Swal from 'sweetalert2'
import moment from 'moment'
import Multiselect from 'vue-multiselect'
import McRadioButton from '@/components/McRadioButton'
import McButton from '@/components/McButton'
import McEmptyState from '@/components/McEmptyState'
import IntegrationLogHistoryModal from './components/IntegrationLogHistoryModal'
import { Helper } from '@/mixin/helper'
import McTable from '@/components/McTable'
import DriverRegisteredIcon from './components/DriverRegisteredIcon'

import { required, requiredIf, minValue } from 'vuelidate/lib/validators'

import {
  GET_VEHICLE_ID,
  VEHICLE_MUTATION_CREATE,
  VEHICLE_MUTATION_UPDATE,
} from '@/services/api/master/fleet'
import { GET_VEHICLE_TYPE } from '@/services/api/setting/fleet/fleetType'
import { GET_MODEL } from '@/services/api/setting/fleet/fleetModel'
import { GET_THERMO } from '@/services/api/setting/fleet/thermoType'
import { GET_EMPLOYEES } from '@/services/api/master/employees'
import { GET_DEVICES } from '@/services/api/master/tracking'
import { GET_GEOFENCES } from '@/services/api/master/geofence'
import { mapGetters } from 'vuex'
import * as boxType from '@/services/rest-api-vsms/lib/fleet/box-type'
import datePickerLang from '@/helpers/date-picker-lang'
import LoadingSkeleton from './components/LoadingSkeleton.vue'
import { GET_VGROUPS_PAGINATED } from '@/services/api/vehicle/vgroup'
import { GET_IBEACONS } from '@/services/api/master/ibeacon'
import { GET_OPERATIONAL_NOTES } from '@/services/api/setting/fleet/operationalNotes'
import { GET_EMPLOYEES_PAGINATED as GET_DRIVERS_WITH_IDENTIFICATION } from '@/services/api/master/rfid-facerecognition'
import { GET_DISTRICTS, GET_PROVINCES, GET_CITIES } from '@/services/api/master/address'
import { MixPanel } from '@/mixin/mixpanel'

import contractFields from './lib/contractFields'
import * as Contract from '@/services/rest-api/lib/contract/customer-contract'
import { formatIndexDate } from '@/helpers/tzDate'

moment.locale('id')
/**
 * Starter component
 */
export default {
  page: {
    title: 'Form Kendaraan',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Multiselect,
    McRadioButton,
    McButton,
    LoadingSkeleton,
    McEmptyState,
    IntegrationLogHistoryModal,
    McTable,
  },
  mixins: [Helper, MixPanel],
  apollo: {
    vehicleTypes: {
      fetchPolicy: 'no-cache',
      query: GET_VEHICLE_TYPE,
      variables() {
        return {
          filter: {
            isActive: true,
          },
        }
      },
    },
    employees: {
      query: GET_EMPLOYEES,
      fetchPolicy: 'no-cache',
      variables() {
        return {
          filter: {
            hasRelation: false,
            isDriver: true,
            isActive: true,
            vehicleCategory: this.vehicleCategory ?? undefined,
          },
        }
      },
    },
    devices: {
      query: GET_DEVICES,
      fetchPolicy: 'no-cache',
      variables() {
        return {
          filter: {
            hasRelation: false,
          },
        }
      },
    },
    geofences: {
      query: GET_GEOFENCES,
      fetchPolicy: 'no-cache',
      variables() {
        return {
          filter: {
            isGarage: true,
          },
        }
      },
      result({ data, loading }) {
        if (!loading) {
          this.geofences = data.geofences.geofences.data
        }
      },
    },
    vehicle: {
      query: GET_VEHICLE_ID,
      fetchPolicy: 'no-cache',
      variables() {
        return {
          filter: {
            id: parseInt(this.$route.params.id),
          },
        }
      },
      // Disable the query
      skip() {
        return !this.$route.params.id
      },
      result({ data, loading }) {
        if (!loading) {
          if (!data.vehicle.isSuccessful) {
            this.$mcToast.warning(data.vehicle.message)
          }
          this.userLogging('Access', this.$route, data.vehicle.vehicle.licensePlate)
          this.initEditPage(data.vehicle.vehicle)
          this.sensors = data.vehicle?.vehicle?.sensor
          const ibeaconSensor = this.sensors.find(
            (sensor) => sensor.sensorCode === 44 || sensor.sensorCode === 45
          )

          if (ibeaconSensor) {
            this.ibeacon.status = ibeaconSensor.statusBool === true
            this.hasSensorIbeacon = true
            this.formOld.ibeaconStatus = this.ibeacon.status
          } else {
            this.ibeacon.status = false
            this.hasSensorIbeacon = false
          }

          if (this.hasDriverCompatibility) {
            this.vehicleCategory = data.vehicle.vehicle.vehicleType.category
          }
        }
      },
    },
  },
  data() {
    return {
      DriverRegisteredIcon,
      selected: [],
      selectedModel: [],
      allSelected: false,
      indeterminate: true,
      selectedFleet: null,
      tData: [],
      documentRowKey: 0,
      isSubmit: false,
      formOld: {},
      form: {
        licensePlate: null,
        fleetType: null,
        status: 'I',
        device: null,
        sourceMode: 'GPS',
        hullNo: null,
        chassisNumber: null,
        machineNumber: null,
        boxType: null,
        thermoType: null,
        model: null,
        odometer: 0,
        carrosserie: null,
        thirdPartyId: null,
        firstDriver: null,
        geofence: null,
        unitYear: null,
        vgroups: null,
        district: null,
        operationalNotes: [],
        registeredDriver: [],
      },

      statusOptions: [
        {
          key: 'I',
          label: 'Aktif',
        },
        {
          key: 'R',
          label: 'Perbaikan',
        },
        {
          key: 'A',
          label: 'Arsip',
        },
      ],

      vehicleModels: {
        vehicleModels: [],
      },

      vehicleTypes: {
        vehicleTypes: {
          data: [],
        },
      },

      vehicleCategory: null,

      boxTypes: {
        boxTypes: [],
      },

      employees: {
        employees: [],
      },

      devices: {
        devices: [],
      },

      geofences: [],

      vehTypeOptions: [],
      docTypeOptions: [
        'STNK',
        'BPKB',
        'KIR',
        'KIR Head',
        'KIR Chassis',
        'Pajak Tahunan',
        'STID',
        'KP',
        'SIPA',
        'SKPD',
        'Uji Emisi',
        'B3',
        'KLHK',
        'Kemenhub',
        'Asuransi',
        'Kontrak Sewa',
        'IBM',
        'Reklame',
        'TERA',
        'KPS',
        'Kartu Pelindo',
        'Commissioning',
        'Tes Brake',
        'KIM',
        'Dry Test',
        'Tes Kedap',
        'Other',
      ],
      loading: true,
      districtFilterProvince: null,
      districtFilterCity: null,
      fullObject: {
        model: {},
        vehicleType: {},
        firstDriver: {},
        status: {
          key: 'I',
          label: 'Aktif',
        },
        thermoType: {},
        geofence: {},
        device: {},
        vgroup: {},
        operationalNotes: [],
        registeredDriver: [],
        district: {},
        districtFilterProvince: {},
        districtFilterCity: {},
      },
      ibeacon: {
        status: true,
        id: null,
        name: null,
        battery: null,
        description: null,
      },
      sensors: [],
      hasSensorIbeacon: false,
      hasDataIbeacoon: false,
      contractFields: contractFields,
      isTableContractDataAvailable: false,
    }
  },
  validations: {
    form: {
      licensePlate: { required },
      fleetType: { required },
      model: { required },
      odometer: { minValue: minValue(0) },
    },
    tData: {
      $each: {
        docType: {
          required: requiredIf(function () {
            return this.tData !== undefined && this.tData.length > 0
          }),
        },
        validUntil: {
          required: requiredIf(function () {
            return this.tData !== undefined && this.tData.length > 0
          }),
        },
      },
    },
  },
  computed: {
    fields() {
      return [
        {
          key: 'check',
        },
        {
          key: 'type',
          label: this.$t('master.form.fleet.documentPermit.name'),
          tdClass: 'mc-table--50',
        },
        {
          key: 'number',
          label: this.$t('master.form.fleet.documentPermit.number'),
          tdClass: 'mc-table--50',
        },
        {
          key: 'expired',
          label: this.$t('master.form.fleet.documentPermit.expired'),
        },
        {
          key: 'status',
          label: 'Status',
        },
      ]
    },
    title() {
      return this.$route.params.id === undefined
        ? this.$t('master.form.fleet.new')
        : this.$t('master.form.fleet.change')
    },
    items() {
      return [
        {
          text: this.$t('menuitems.masterData.text'),
          to: '/master',
        },
        {
          text: this.$t('menuitems.masterData.list.fleet'),
          to: '/master/fleet',
        },
        {
          text:
            this.$route.params.id === undefined
              ? this.$t('master.form.fleet.new')
              : this.form.licensePlate,
        },
      ]
    },
    datePickerLang() {
      return datePickerLang()
    },

    yearShow() {
      let year = this.form.unitYear
      if (year !== null) {
        let now = moment().format('YYYY-01-01')
        let pick = moment(year).format('YYYY-01-01')
        let diff = moment(now).diff(pick, 'years')

        return year + ` (${diff})`
      }
      return null
    },
    docTypeUnSelected() {
      let selectedDoc = this.tData.map((item) => item.docType)
      selectedDoc = selectedDoc.filter((item) => item != null)

      let options = this.docTypeOptions.filter((item) => {
        return !selectedDoc.includes(item)
      })

      return options
    },
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
      hasAccessAll: 'identity/hasAccessAll',
      getFeatureFlagValue: 'identity/getFeatureFlagValue',
      isWhitelabel: 'identity/isWhitelabel',
      isMetrack: 'identity/isMetrack',
    }),
    resourcefulQuery() {
      return {
        models: async (opts) => {
          let result = {}
          const res = await this.$apollo.query({
            query: GET_MODEL,
            fetchPolicy: 'no-cache',
            variables: {
              filter: {
                search: opts.search,
              },
            },
          })

          result = {
            metadata: {
              total_count: 5,
              page: 1,
            },
            data: {
              paginated_result: res.data.vehicleModels.vehicleModels,
            },
          }

          return result
        },
        vehicleType: (opts) => {
          let result = {}
          const self = this

          self.chooseVehType()
          if (opts.search) {
            self.chooseVehType(opts.search)
          }
          let vehicleType = self.vehTypeOptions
          result = {
            metadata: {
              total_count: 5,
              page: 1,
            },
            data: {
              paginated_result: vehicleType,
            },
          }

          return result
        },
        firstDriver: (opts) => {
          let result = {}
          let employees = this.employees.employees
          let employeeIds = employees.map((item) => item.userId)
          if (this.form.firstDriver != null) {
            if (!employeeIds.includes(this.form.firstDriver))
              employees.unshift(this.fullObject.firstDriver)
          }
          if (opts.search) {
            employees = employees.filter((item) => this.isContains(opts.search, item.fullname))
          }
          result = {
            metadata: {
              total_count: 5,
              page: 1,
            },
            data: {
              paginated_result: employees,
            },
          }

          return result
        },
        statusOption: (opts) => {
          let result = {}
          let statuses = this.statusOptions
          if (opts.search) {
            statuses = statuses.filter((item) => this.isContains(opts.search, item.label))
          }
          result = {
            metadata: {
              total_count: statuses.length,
              page: 1,
            },
            data: {
              paginated_result: statuses,
            },
          }

          return result
        },
        registeredDriverOption: async (opts) => {
          let result = {}

          try {
            const filter = {
              filter: {
                pagination: {
                  show: opts.limit,
                  page: opts.page,
                },
                search: opts.search,
                isActive: true,
                isDriver: true,
              },
            }

            const res = await this.$apollo.query({
              query: GET_DRIVERS_WITH_IDENTIFICATION,
              variables: filter,
              fetchPolicy: 'no-cache',
            })

            const data = res.data.employeesPaginated.employeesPaginated

            result = {
              metadata: {
                total_page: Math.ceil(data.pagination.total / data.pagination.show),
                total_count: data.pagination.total,
                count: data.pagination.total,
                page: opts.page,
              },
              data: {
                paginated_result: data?.data,
              },
            }
          } catch (e) {
            /* eslint-disable-next-line no-console */
            console.error('Error fetching registered driver options:', e)
            result = {
              metadata: {
                total_count: 0,
                page: 1,
              },
              data: {
                paginated_result: [],
              },
            }
          }
          return result
        },
        thermoTypes: async (opts) => {
          let result = {}
          const res = await this.$apollo.query({
            query: GET_THERMO,
            fetchPolicy: 'no-cache',
            variables: {
              filter: {
                pagination: {
                  page: opts.page,
                  show: opts.limit,
                },
                search: opts.search,
              },
            },
          })

          let thermoTypes = res.data.thermoTypes.thermoTypes

          result = {
            metadata: {
              total_count: 5,
              page: 1,
            },
            data: {
              paginated_result: thermoTypes.data,
            },
          }

          return result
        },
        boxTypes: async (opts) => {
          let result = {}
          const queryParam = {
            limit: 9999999,
            page: 1,
          }
          let boxTypes = []
          await boxType.get(queryParam).then((response) => {
            boxTypes = response.data.paginated_result
          })

          if (opts.search) {
            boxTypes = boxTypes.filter((item) => this.isContains(opts.search, item.name))
          }

          result = {
            metadata: {
              total_count: 5,
              page: 1,
            },
            data: {
              paginated_result: boxTypes,
            },
          }
          return result
        },
        geofences: async (opts) => {
          let geofences = this.geofences

          if (opts.search) {
            geofences = geofences.filter((item) => this.isContains(opts.search, item.fenceName))
          }
          let result = {}
          result = {
            metadata: {
              total_count: 5,
              page: 1,
            },
            data: {
              paginated_result: geofences,
            },
          }
          return result
        },
        devices: async (opts) => {
          let devices = this.devices.devices

          let deviceIds = devices.map((item) => item.imei)
          if (this.form.device != null) {
            if (!deviceIds.includes(this.form.device)) devices.unshift(this.fullObject.device)
          }
          if (opts.search) {
            devices = devices.filter((item) => this.isContains(opts.search, item.identifier))
          }
          let result = {}
          result = {
            metadata: {
              total_count: devices.length > 5 ? 5 : devices.length,
              page: 1,
            },
            data: {
              paginated_result: devices,
            },
          }
          return result
        },
        vGroups: async (opts) => {
          let result = {}

          const filter = {
            pagination: {
              page: opts.page,
              show: opts.limit,
            },
            search: opts.search,
          }

          const res = await this.$apollo.query({
            query: GET_VGROUPS_PAGINATED,
            fetchPolicy: 'no-cache',
            variables: {
              filter: {
                ...filter,
              },
            },
          })

          let vgroups = res.data.vgroupsPaginated.vgroups

          result = {
            metadata: {
              total_count: vgroups.pagination.total,
              page: vgroups.pagination.page,
            },
            data: {
              paginated_result: vgroups.data,
            },
          }

          return result
        },
        operationalNotes: async (opts) => {
          let result = {}

          const filter = {
            pagination: {
              page: opts.page,
              show: opts.limit,
            },
            search: opts.search,
            orderBy: this.handleOrderBy(opts.sorts),
          }

          if (filter?.orderBy && !filter.orderBy.length) delete filter.orderBy
          if (filter?.search && !filter.search) delete filter.search

          const res = await this.$apollo.query({
            query: GET_OPERATIONAL_NOTES,
            fetchPolicy: 'no-cache',
            variables: {
              filter,
            },
          })

          const responseData = res.data?.operationalNotes?.operationalNotes

          if (!responseData || !responseData.data || !responseData.pagination) {
            return {
              metadata: {
                total_count: 0,
                page: 1,
              },
              data: {
                paginated_result: [],
              },
            }
          }

          result = {
            metadata: {
              total_count: responseData.pagination.total || 0,
              page: responseData.pagination.page || 1,
            },
            data: {
              paginated_result: responseData.data.map((item) => ({
                id: '',
                text: item.text,
              })),
            },
          }

          return result
        },
        districts: async (opts) => {
          const filter = {
            pagination: {
              page: opts.page,
              show: opts.limit,
            },
            search: opts.search || undefined,
            provinceId: this.fullObject.districtFilterProvince?.id,
            cityId: this.fullObject.districtFilterCity?.id,
          }

          const { data, pagination, ids } = await this.searchDistricts(filter)

          const districtOptions = (data || []).map((item) => ({
            key: item.name,
            id: item.regionId,
            name: item.name,
            city: item.city.name,
            province: item.province.name,
          }))

          return {
            metadata: {
              total_count: pagination?.total || districtOptions.length,
              page: pagination?.page || opts.page || 1,
            },
            data: {
              paginated_result: districtOptions,
              ids,
            },
          }
        },
        provinces: async (opts) => {
          const filter = {
            pagination: {
              page: opts.page,
              show: opts.limit,
            },
            search: opts.search || undefined,
          }

          const { data, pagination } = await this.searchProvinces(filter)

          const provinceOptions = (data || []).map((item) => ({
            id: item.regionId,
            name: item.name,
          }))

          return {
            metadata: {
              total_count: pagination?.total || provinceOptions.length,
              page: pagination?.page || opts.page || 1,
            },
            data: {
              paginated_result: provinceOptions,
            },
          }
        },
        cities: async (opts) => {
          const filter = {
            pagination: {
              page: opts.page,
              show: opts.limit,
            },
            search: opts.search || undefined,
            provinceId: this.fullObject.districtFilterProvince?.id,
          }

          const { data, pagination } = await this.searchCities(filter)

          const cityOptions = (data || []).map((item) => ({
            id: item.regionId,
            name: item.name,
          }))

          return {
            metadata: {
              total_count: pagination?.total || cityOptions.length,
              page: pagination?.page || opts.page || 1,
            },
            data: {
              paginated_result: cityOptions,
            },
          }
        },
      }
    },

    vGroupFields() {
      return [
        {
          key: 'name',
          label: this.$t('global.object.fleetGroup'),
        },
        {
          key: 'totalVehicle',
          label: this.$t('global.object.totalFleet'),
        },
      ]
    },
    operationalNotesFields() {
      return [
        {
          key: 'text',
          label: this.$t('master.form.fleet.operationalNotes'),
          isSortable: true,
        },
      ]
    },
    districtFields() {
      return [
        {
          key: 'name',
          label: this.$t('master.form.address.district'),
        },
        {
          key: 'city',
          label: this.$t('master.form.address.regencyCity'),
        },
        {
          key: 'province',
          label: this.$t('master.form.address.province'),
        },
      ]
    },
    hasDriverCompatibility() {
      return this.hasAccessAll([
        'driver-compatibility:read',
        'driver-compatibility:create',
        'driver-compatibility:update',
      ])
    },
    illustrationPath() {
      if (this.isWhitelabel() || this.isMetrack()) {
        return require(`@/assets/images/illustration/whitelabel/no-data.svg`)
      }
      return require(`@/assets/images/illustration/saas/no-data.svg`)
    },
    hasAccessCustomerContract() {
      return this.hasAccessAll([
        'tms-customer-contract:create',
        'tms-customer-contract:delete',
        'tms-customer-contract:read',
        'tms-customer-contract:update',
      ])
    },
    contractApiClient() {
      const filters = 'vehicle.id eq ' + this.$route.params.id
      let getContract = Contract.getWithFilters(filters)

      return {
        get: getContract,
      }
    },
    hasScopeRfidAndFaceRecognition() {
      return this.hasAccessAll(['d10a-default-rfid&fr:read', 'd10a-default-rfid&fr:update'])
    },
    headerFilterTopComponent() {
      return [
        {
          name: 'province',
          type: 'select-resourceful-v2',
          placeholder: this.$t('master.form.address.province'),
          trackBy: 'id',
          optionsGetter: this.resourcefulQuery.provinces,
          optionLabelFn: ({ item }) => item.name,
          fullObject: this.fullObject.districtFilterProvince,
        },
        {
          name: 'city',
          type: 'select-resourceful-v2',
          placeholder: this.$t('master.form.address.city'),
          trackBy: 'id',
          optionsGetter: this.resourcefulQuery.cities,
          optionLabelFn: ({ item }) => item.name,
          fullObject: this.fullObject.districtFilterCity,
        },
      ]
    },
    hasFeatureVehicleDistrictMgm() {
      const data = this.getFeatureFlagValue('customFeature.mgm')
      return (
        Array.isArray(data?.company_id) &&
        data.company_id.includes(this.getCompanyId()) &&
        data?.features?.vehicle_district
      )
    },
  },
  watch: {
    selected(newValue) {
      // Handle changes in individual flavour checkboxes
      if (newValue.length === 0) {
        this.indeterminate = false
        this.allSelected = false
      } else if (newValue.length == this.tData.length) {
        this.indeterminate = false
        this.allSelected = true
      } else {
        this.indeterminate = true
        this.allSelected = false
      }
    },
    'fullObject.districtFilterProvince': {
      handler() {
        // Reset city filter when province changes
        this.fullObject.districtFilterCity = {}
      },
      deep: true,
    },
  },
  mounted() {
    this.$apollo.queries.vehicle.refetch().then((_) => {
      if (this.hasDriverCompatibility) {
        this.$apollo.queries.employees.refetch()
      }
    })
    if (!this.hasDriverCompatibility) {
      this.$apollo.queries.employees.refetch()
    }
    this.$apollo.queries.devices.refetch()

    for (let i = 0; i < this.tData.length; i++) {
      this.selectedModel.push(false)
    }
  },
  methods: {
    formatIndexDate,
    initEditPage(item) {
      this.loading = true
      this.tData.splice(0, this.tData.length)
      let statusLabel = ''
      if (item.status === 'I') {
        statusLabel = 'Aktif'
      } else if (item.status === 'R') {
        statusLabel = 'Perbaikan'
      } else if (item.status === 'A') {
        statusLabel = 'Arsip'
      }

      this.fullObject.model = {
        model: `${item.vehicleType?.manufacturer} - ${item.vehicleType?.model}`,
      }

      this.chooseVehType()

      const operationalNotesObjects = item.operationalNotes
        ? item.operationalNotes.map((note) => ({ id: '', text: note }))
        : []

      this.form = {
        licensePlate: item.licensePlate,
        model: `${item.vehicleType?.manufacturer} - ${item.vehicleType?.model}`,
        fleetType: item.vehicleType.type,
        status: item.status,
        device: item.device ? item.device.imei : null,
        hullNo: item.hullNo,
        chassisNumber: item.chassisNumber,
        machineNumber: item.machineNumber,
        boxType: item.boxTypeObject ? item.boxTypeObject.boxTypeId : null,
        thermoType: item.thermoType,
        unitYear: item.year ? item.year.toString() : null,
        odometer: item.odometer,
        carrosserie: item.carrosserie,
        thirdPartyId: item.thirdPartyId,
        firstDriver: item.driver1 ? item.driver1.userId : null,
        geofence: item.garage ? item.garage.geofenceId : null,
        sourceMode: !this.hasAccess(['driver_app_tracker:read']) ? 'GPS' : item.sourceMode,
        vgroups: item.vehicle2Vgroup ? item.vehicle2Vgroup.map((item) => item.vgroup.id) : null,
        operationalNotes: item.operationalNotes ? item.operationalNotes : [],
        registeredDriver: item?.identification
          ? item.identification.map((item) => item.driverId)
          : [],
        district: item.vehicle2Regions
          ? item.vehicle2Regions.map((item) => item.region.regionId)
          : null,
      }

      this.fullObject.vehicleType = item.vehicleType
      this.fullObject.device = item.device
      this.fullObject.boxType = item.boxTypeObject
        ? { name: item.boxTypeObject.name, id: item.boxTypeObject.boxTypeId }
        : null
      this.fullObject.geofence = item.garage
      this.fullObject.thermoType = { text: item.thermoType }
      this.fullObject.status = {
        key: item.status,
        label: statusLabel,
      }
      this.fullObject.vgroup = item.vehicle2Vgroup.map((item) => item.vgroup)
      this.fullObject.district = item.vehicle2Regions
        ? item.vehicle2Regions.map((item) => ({
            id: item.region.regionId,
            name: item.region.name,
          }))
        : null
      this.fullObject.operationalNotes = operationalNotesObjects
      this.fullObject.firstDriver = item.driver1
        ? {
            userId: item.driver1 ? item.driver1.userId : null,
            isDriver: item.driver1 ? item.driver1.isDriver : null,
            fullname: item.driver1 ? item.driver1.fullname : null,
            email: item.driver1 ? item.driver1.email : null,
          }
        : null
      this.fullObject.registeredDriver = item?.identification
        ? item.identification.map((item) => {
            return {
              userId: item.driverId,
              fullname: item.fullname,
            }
          })
        : []
      let vehicleDocs = []
      this.documentRowKey = 0
      item.vehicleDocs.forEach((row, index) => {
        this.tData.push({
          rowKey: `vehicle-doc-${this.documentRowKey++}`,
          docType: row.docType,
          docNumber: row.docNumber || null,
          validUntil: row.validUntil ? this.momentYmD(row.validUntil) : null,
        })

        vehicleDocs.push({
          docType: row.docType,
          docNumber: row.docNumber || null,
          validUntil: row.validUntil || null,
        })

        this.checkStatus(index)
      })

      this.formOld = {
        licensePlate: item.licensePlate,
        model: {
          model: `${item.vehicleType.manufacturer} - ${item.vehicleType.model}`,
        },
        fleetType: item.vehicleType,
        status: {
          key: item.status,
          label: statusLabel,
        },
        device: item.device ? item.device : null,
        hullNo: item.hullNo,
        chassisNumber: item.chassisNumber,
        machineNumber: item.machineNumber,
        boxType: item.boxTypeObject
          ? { name: item.boxTypeObject.name, id: item.boxTypeObject.boxTypeId }
          : null,
        thermoType: { text: item.thermoType },
        unitYear: item.year ? item.year.toString() : null,
        odometer: item.odometer,
        carrosserie: item.carrosserie,
        thirdPartyId: item.thirdPartyId,
        firstDriver: item.driver1
          ? {
              userId: item.driver1 ? item.driver1.userId : null,
              isDriver: item.driver1 ? item.driver1.isDriver : null,
              fullname: item.driver1 ? item.driver1.fullname : null,
              email: item.driver1 ? item.driver1.email : null,
            }
          : null,
        geofence: item.garage,
        vehicleDocs: vehicleDocs,
        sourceMode: item.sourceMode,
        vgroups: item.vehicle2Vgroup ? item.vehicle2Vgroup.map((item) => item.vgroup.id) : null,
        operationalNotes: item.operationalNotes ? item.operationalNotes : [],
        registeredDriver: item?.identification
          ? item.identification.map((item) => item.driverId)
          : [],
        district: item.vehicle2Regions
          ? item.vehicle2Regions.map((item) => item.region.regionId)
          : null,
      }

      this.loading = false
    },
    chooseVehType(search) {
      const model = this.fullObject?.model?.model?.split(' - ')

      let vehType = this.vehicleTypes.vehicleTypes.data.filter(function (row) {
        return row.manufacturer == model[0] && row.model == model[1]
      })

      if (search) {
        vehType = vehType.filter((item) => this.isContains(search, item.type))
      }

      // Only clear the selection if the current vehicle type is not valid for the new model
      if (this.form.fleetType && !vehType.some((item) => item.type === this.form.fleetType)) {
        this.$v.form.fleetType.$model = null
        this.fullObject.vehicleType = null
      }

      const groupByCategory = vehType.reduce((group, row) => {
        const { category } = row
        group[category] = group[category] ?? []
        group[category].push(row)
        return group
      }, {})

      this.vehTypeOptions.splice(0, this.vehTypeOptions.length)
      for (const [key, value] of Object.entries(groupByCategory)) {
        this.vehTypeOptions.push({
          parent: key != 'null' ? key : 'Tidak Memiliki Kategori',
          libs: value,
        })
      }
    },
    chooseVehCategory() {
      const model = this.fullObject?.model?.model?.split(' - ')
      const vehicleType = this.form.fleetType

      let vehCategory = this.vehicleTypes.vehicleTypes.data.filter(function (row) {
        return row.manufacturer === model[0] && row.model === model[1] && row.type === vehicleType
      })

      this.vehicleCategory = vehCategory?.[0]?.category ?? null
    },
    toggleAll(checked) {
      this.selectedModel = []
      this.selected = []
      if (checked) {
        for (let i = 0; i < this.tData.length; i++) {
          this.selected.push(i)
          this.selectedModel.push(true)
        }
      } else {
        for (let i = 0; i < this.tData.length; i++) {
          this.selectedModel.push(false)
        }
        this.selected = []
      }
    },
    checkTable(event, data) {
      if (event) {
        this.selected.push(data.index)
      } else {
        let myIndex = this.selected.indexOf(data.index)
        if (myIndex !== -1) {
          this.selected.splice(myIndex, 1)
        }
      }
    },
    checkStatus(index) {
      const today = new Date()
      const zeroPad = (num, places) => String(num).padStart(places, '0')
      const date =
        today.getFullYear() +
        '-' +
        zeroPad(today.getMonth() + 1, 2) +
        '-' +
        zeroPad(today.getDate(), 2)

      if (date > this.tData[index].validUntil) {
        this.tData[index].status = 'expired'
      } else {
        const range = this.getDatesInRange(date, this.tData[index].validUntil).length
        if (range <= 30) {
          this.tData[index].status = 'near'
        } else {
          this.tData[index].status = 'active'
        }
      }
    },
    addDocumentPermit() {
      this.tData.push({
        rowKey: `vehicle-doc-${this.documentRowKey++}`,
        docType: null,
        docNumber: null,
        validUntil: null,
        status: null,
      })
    },
    toDelete() {
      this.selected.sort()
      this.selected.reverse()
      this.selected.forEach((row) => {
        this.$delete(this.tData, row)
      })
      this.selected = []
      this.selectedModel = []

      this.indeterminate = false
      this.allSelected = false
      for (let i = 0; i < this.tData.length; i++) {
        this.selectedModel.push(false)
      }
    },
    checkEmpty() {
      let isEmpty = true
      let forms = this.form
      let excepts = ['odometer', 'status']
      Object.keys(this.form).forEach(function (key) {
        if (forms[key] != null && forms[key] != '') {
          if (typeof forms[key] !== 'object') {
            if (!excepts.includes(key)) {
              isEmpty = false
            }
          } else {
            if (!excepts.includes(key)) {
              Object.keys(forms[key]).forEach(function (subKey) {
                if (forms[key][subKey] != null && forms[key][subKey] != '') {
                  isEmpty = false
                }
              })
            }
          }
        }
      })

      return isEmpty
    },

    checkChanged() {
      let isChanged = false
      let forms = this.form
      let formOld = this.formOld
      Object.keys(this.form).forEach(function (key) {
        if (forms[key] != formOld[key]) {
          if (key == 'model' && forms[key] != null) {
            if (forms[key].model != formOld[key].model) {
              isChanged = true
            }
          } else if (key == 'status' && forms[key] != null) {
            if (forms[key].key != formOld[key].key) {
              isChanged = true
            }
          } else if (key == 'boxType' && forms[key] != null) {
            if (forms[key] != formOld[key]) {
              isChanged = true
            }
          } else if (key == 'thermoType' && forms[key] != null) {
            if (forms[key].text != formOld[key].text) {
              isChanged = true
            }
          } else if (key == 'firstDriver' && forms[key] != null) {
            if (forms[key].userId != formOld[key].userId) {
              isChanged = true
            }
          } else if (key == 'device' && forms[key] != null) {
            if (forms[key].imei != formOld[key].imei) {
              isChanged = true
            }
          } else {
            isChanged = true
          }
        }
      })

      return isChanged
    },

    toCancel() {
      let isEmpty = this.checkEmpty()
      if (this.$route.params.id) {
        isEmpty = !this.checkChanged()
      }

      if (isEmpty) {
        this.$router.push('/master/fleet')
      } else {
        Swal.fire({
          title: this.$t('global.alert.text.cancel'),
          text: this.$t('global.alert.text.confirmCancel'),
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: this.$t('global.yes'),
          cancelButtonText: this.$t('global.no'),
        }).then((result) => {
          if (result.value) {
            this.$router.push('/master/fleet')
          }
        })
      }
    },
    handleOk() {
      // Trigger submit handler
      this.$refs.form.showErrors()
      this.handleSubmit()
    },
    handleSubmit() {
      // Exit when the form isn't valid
      if (this.$v.$invalid) {
        if (this.$v.tData.$invalid) {
          this.$mcToast.error(this.$t('master.form.fleet.documentPermit.docsReq'))
        }
        this.$v.$touch()
        return
      }

      if (this.$refs.form.hasErrors) return

      this.isSubmit = true
      let vehicleDocs = []
      this.tData.forEach((row) => {
        vehicleDocs.push({
          docType: row.docType,
          docNumber: row.docNumber || null,
          validUntil: row.validUntil || null,
        })
      })

      let input = {
        vehicleDocs: vehicleDocs,
        driver1Id: this.form.firstDriver ? this.fullObject.firstDriver.userId : null,
        garageId: this.form.geofence ? this.fullObject.geofence.geofenceId : null,
        odometer: this.form.odometer,
        status: this.form.status ? this.fullObject.status.key : null,
        imei: this.form.device ? this.fullObject.device.imei : null,
        licensePlate: this.$v.form.licensePlate.$model,
        vehicleTypeId: this.fullObject.vehicleType.vehicleTypeId,
        thermoType: this.form.thermoType ? this.fullObject.thermoType.text : null,
        boxTypeId: this.form.boxType ? this.fullObject.boxType.id : null,
        hullNo: this.form.hullNo,
        chassisNumber: this.form.chassisNumber,
        machineNumber: this.form.machineNumber,
        carrosserie: this.form.carrosserie ? this.form.carrosserie : '',
        thirdPartyId: this.form.thirdPartyId,
        year: parseInt(this.form.unitYear),
        sourceMode: this.form.sourceMode,
        vgroups: this.form.vgroups,
        regions: this.form.district ? this.form.district.map((item) => parseInt(item, 10)) : [],
        operationalNotes: this.form.operationalNotes ? this.form.operationalNotes : [],
      }

      if (this.hasScopeRfidAndFaceRecognition) {
        input.driverIds = this.form.registeredDriver ? this.form.registeredDriver : []
      }

      if (!this.$route.params.id) {
        this.$apollo
          .mutate({
            mutation: VEHICLE_MUTATION_CREATE,
            variables: {
              input: input,
            },
          })
          .then((response) => {
            if (response.data.createVehicle.isSuccessful) {
              this.$mcToast.success(this.$t('liveView.text.dataSaved'))
              this.$router.push({ name: 'Master Fleet' })
            } else {
              this.isSubmit = false
              this.$mcToast.error(response.data.createVehicle.message)
            }
          })
      } else {
        let inputOld = {
          driver1Id: this.formOld.firstDriver ? this.formOld.firstDriver.userId : null,
          garageId: this.formOld.geofence ? this.formOld.geofence.geofenceId : null,
          odometer: parseInt(this.formOld.odometer),
          status: this.formOld.status ? this.formOld.status.key : null,
          imei: this.formOld.device ? this.formOld.device.imei : null,
          licensePlate: this.formOld.licensePlate,
          vehicleTypeId: this.formOld.fleetType.vehicleTypeId,
          thermoType: this.formOld.thermoType ? this.formOld.thermoType.text : null,
          boxTypeId: this.formOld.boxType ? this.formOld.boxType.id : null,
          hullNo: this.formOld.hullNo,
          chassisNumber: this.formOld.chassisNumber,
          machineNumber: this.formOld.machineNumber,
          carrosserie: this.formOld.carrosserie,
          thirdPartyId: this.formOld.thirdPartyId,
          year: parseInt(this.formOld.unitYear),
          vehicleDocs: this.formOld.vehicleDocs,
          sourceMode: this.formOld.sourceMode,
          vgroups: this.formOld.vgroups,
          regions: this.formOld.district
            ? this.formOld.district.map((item) => parseInt(item, 10))
            : [],
          operationalNotes: this.formOld.operationalNotes ? this.formOld.operationalNotes : [],
        }

        input = { ...input, vehicleId: this.form.vehicleId }
        if (this.hasSensorIbeacon) {
          input.ibeaconSensorActive = JSON.parse(this.ibeacon.status)
          inputOld.ibeaconSensorActive = JSON.parse(this.formOld.ibeaconStatus)
        }

        if (this.hasScopeRfidAndFaceRecognition) {
          inputOld.driverIds = this.formOld.registeredDriver ? this.formOld.registeredDriver : []
        }

        this.$apollo
          .mutate({
            mutation: VEHICLE_MUTATION_UPDATE,
            variables: {
              input: {
                id: parseInt(this.$route.params.id),
                oldData: inputOld,
                newData: input,
              },
            },
          })
          .then((response) => {
            if (response.data.updateVehicle.isSuccessful) {
              this.$mcToast.success(this.$t('global.alert.text.changed'))
              this.$router.push({ name: 'Master Fleet' })
            } else {
              let message = response.data.updateVehicle.message
              if (message.includes('Vehicle does not have device')) {
                this.$mcToast.error(this.$t('global.alert.text.fleetHasNoDevice'))
                this.isSubmit = false
                return
              }
              if (
                message.includes('Vehicle connected to Running') &&
                message.includes('Service Schedule')
              ) {
                this.$mcToast.error(this.$t('master.list.fleet.errorConnectedService'))
                this.isSubmit = false
                return
              }
              this.$mcToast.error(response.data.updateVehicle.message)
              this.isSubmit = false
            }
          })
      }
    },

    disabledAfterToday(date) {
      const today = new Date()
      today.setHours(0, 0, 0, 0)
      return date > today
    },

    async getIbeacon() {
      const res = await this.$apollo.query({
        fetchPolicy: 'no-cache',
        query: GET_IBEACONS,
        variables: {
          filter: {
            vehicleIds: [Number(this.$route.params.id)],
          },
        },
      })
      const result = res.data.getIbeacons.getIbeacons.data

      if (result.length > 0) {
        this.hasDataIbeacoon = true
        this.ibeacon.id = result[0]?.ibeaconId ?? null
        this.ibeacon.name = result[0]?.name ?? null
        this.ibeacon.battery = result[0]?.battery ?? null
        this.ibeacon.description = result[0]?.description ?? null
      }
    },

    handleOrderBy(sorts) {
      if (sorts && sorts.length > 0) {
        return sorts.map((sort) => {
          const [key, order] = sort.split(' ')
          return JSON.stringify({ [key]: order })
        })
      }
      return undefined
    },

    getInitialObjectOperationalNotes(form) {
      if (!form?.operationalNotes) return

      return form.operationalNotes.map((item) => {
        return { id: '', text: item }
      })
    },

    handleDataAvailable(isAvailable) {
      this.isTableContractDataAvailable = isAvailable
    },
    openContract(id) {
      const route = this.$router.resolve({
        name: 'Master Customer Contract Detail',
        params: { contractId: id },
      })

      window.open(route.href, '_blank')
    },
    async searchDistricts(filter) {
      const response = await this.$apollo.query({
        query: GET_DISTRICTS,
        fetchPolicy: 'no-cache',
        variables: {
          filter,
        },
      })

      return {
        data: response?.data?.data?.districts?.data || [],
        pagination: response?.data?.data?.districts?.pagination || {},
        ids: response?.data?.data?.districts?.ids || [],
      }
    },
    async searchProvinces(filter) {
      const response = await this.$apollo.query({
        query: GET_PROVINCES,
        fetchPolicy: 'no-cache',
        variables: {
          filter,
        },
      })

      return {
        data: response?.data?.data?.provinces?.data || [],
        pagination: response?.data?.data?.provinces?.pagination || {},
      }
    },
    async searchCities(filter) {
      const response = await this.$apollo.query({
        query: GET_CITIES,
        fetchPolicy: 'no-cache',
        variables: {
          filter,
        },
      })

      return {
        data: response?.data?.data?.cities?.data || [],
        pagination: response?.data?.data?.cities?.pagination || {},
      }
    },
  },
}
</script>

<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" :items="items" class="mc-page-three" />

      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <div class="float-end">
          <McButton
            v-if="
              hasAccess(['vehicle_audit_logs:read', 'd1a-default-mdkendaraan:read']) &&
              $route.params?.id
            "
            :text="$t('global.historyUpdate')"
            variant="secondary"
            class="ms-2"
            icon="icon-large icon-outline_file-text"
            @click="
              track('Open Change Log Master Vehicle')
              $router.push({
                name: 'Master Fleet Update History',
                params: { id: $route.params.id },
              })
            "
          />

          <McButton
            v-if="hasAccessAll(['webhook-log-event-md:read', 'webhook-event-du1-mdv1:read'])"
            class="ms-2"
            variant="secondary"
            text="Riwayat Integrasi"
            icon="icon-large icon-outline_file-text"
            @click="$bvModal.show('integration-log-modal-value-help')"
          />

          <McButton
            variant="secondary"
            class="mx-2"
            icon="icon-fill_close"
            :text="$t('global.cancel')"
            @click="toCancel"
          />

          <McButton
            variant="primary"
            type="button"
            :disabled="isSubmit"
            icon="icon-outline_save"
            :text="$t('global.save')"
            @click="handleOk()"
          />
        </div>
      </div>
    </div>

    <b-skeleton-wrapper :loading="$route.params.id && loading">
      <template #loading>
        <LoadingSkeleton />
      </template>
      <FormulateForm ref="form" v-model="form" class="mc-form">
        <h4 class="card-title">
          {{ $t('master.form.fleet.fleetInformation') }}
        </h4>

        <b-card>
          <b-row>
            <b-col sm="12" md="3">
              <FormulateInput
                id="licensePlate"
                name="licensePlate"
                validation="required:trim"
                help="required"
                :label="$t('master.form.fleet.licensePlate')"
                :placeholder="$t('master.form.fleet.licensePlate')"
                :validation-messages="{
                  required: `${$t('master.form.fleet.licensePlate')} ${$t(
                    'global.validation.required'
                  )}`,
                }"
              />
            </b-col>
            <b-col sm="12" md="3">
              <FormulateInput
                id="manufacture"
                v-model="form.model"
                name="manufacture"
                type="select-resourceful-v2"
                trackBy="model"
                validation="required"
                help="required"
                :label="$t('master.form.fleet.manufacture')"
                :placeholder="`${$t('global.form.select')} ${$t('master.form.fleet.manufacture')}`"
                :validation-messages="{
                  required: `${$t('global.object.manufacture')} ${$t(
                    'global.validation.required'
                  )}`,
                }"
                :optionsGetter="resourcefulQuery.models"
                :optionLabelFn="({ item }) => item.model"
                :taggable="false"
                :multiple="false"
                :fullObject="fullObject.model"
                @input="chooseVehType"
                @update:fullObject="($event) => (fullObject.model = $event)"
              />
            </b-col>
            <b-col sm="12" md="3">
              <FormulateInput
                id="type"
                v-model="form.fleetType"
                name="type"
                type="select-resourceful-v2"
                group-values="libs"
                group-label="parent"
                trackBy="type"
                validation="required"
                help="required"
                :label="$t('master.form.fleet.vehicleType')"
                :placeholder="`${$t('global.form.select')} ${$t('master.form.fleet.vehicleType')}`"
                :validation-messages="{
                  required: `${$t('global.field.vehicleType')} ${$t('global.validation.required')}`,
                }"
                :optionsGetter="resourcefulQuery.vehicleType"
                :optionLabelFn="({ item }) => item.type"
                :taggable="false"
                :multiple="false"
                :fullObject="fullObject.vehicleType"
                @input="chooseVehCategory"
                @update:fullObject="($event) => (fullObject.vehicleType = $event)"
              >
                <template #noResult>
                  <span>{{ 'Oops! No elements found.Consider changing the search query.' }}</span>
                </template>
              </FormulateInput>
            </b-col>
            <b-col v-if="hasDriverCompatibility" sm="12" md="3">
              <div class="p-1">
                <label class="teal-300">{{ $t('global.field.vehicleCategory') }}</label>
                <p>{{ vehicleCategory ?? '-' }}</p>
              </div>
            </b-col>
            <b-col sm="12" md="3">
              <div :class="{ 'mt-3': hasDriverCompatibility }">
                <FormulateInput
                  id="boxType"
                  v-model="form.boxType"
                  type="select-resourceful-v2"
                  :placeholder="`${$t('global.form.select')} ${$t('master.form.fleet.boxTypeV2')}`"
                  :label="$t('master.form.fleet.boxTypeV2')"
                  :optionsGetter="resourcefulQuery.boxTypes"
                  :optionLabelFn="({ item }) => item.name"
                  :taggable="false"
                  :multiple="false"
                  :fullObject="fullObject.boxType"
                  @update:fullObject="($event) => (fullObject.boxType = $event)"
                />
              </div>
            </b-col>
            <b-col sm="12" md="3">
              <div class="mt-3">
                <FormulateInput
                  id="unitYear"
                  ref="periodePicker"
                  v-model="form.unitYear"
                  type="date-picker"
                  :placeholder="$t('global.action.selectYear')"
                  format="YYYY"
                  value-type="YYYY"
                  :confirm="true"
                  :confirm-text="$t('global.action.apply')"
                  :disabled-date="disabledAfterToday"
                  :lang="datePickerLang"
                  :label="`${$t('master.form.fleet.unitYear')}`"
                  :first-day-of-week="1"
                  datepickerType="year"
                />
              </div>
            </b-col>
            <b-col sm="12" md="3">
              <div class="mt-3">
                <FormulateInput
                  id="firstDriver"
                  v-model="form.firstDriver"
                  type="select-resourceful-v2"
                  :placeholder="`${$t('global.form.select')} ${$t(
                    'master.form.fleet.currentDriver'
                  )}`"
                  :label="$t('master.form.fleet.currentDriver')"
                  :optionsGetter="resourcefulQuery.firstDriver"
                  :optionLabelFn="({ item }) => item.fullname"
                  trackBy="userId"
                  :taggable="false"
                  :multiple="false"
                  :fullObject="fullObject.firstDriver"
                  @update:fullObject="($event) => (fullObject.firstDriver = $event)"
                />
              </div>
            </b-col>
            <b-col v-if="hasScopeRfidAndFaceRecognition" sm="12" md="3">
              <div class="mt-3">
                <FormulateInput
                  id="registeredDriver"
                  v-model="form.registeredDriver"
                  name="registeredDriver"
                  type="select-resourceful-v3"
                  :placeholder="`${$t('global.form.select')} ${$t(
                    'master.form.fleet.registeredDriver'
                  )}`"
                  :label="$t('master.form.fleet.registeredDriver')"
                  :optionsGetter="resourcefulQuery.registeredDriverOption"
                  :optionLabelFn="({ item }) => item.fullname"
                  :fullObject="fullObject.registeredDriver"
                  selectedLabel="fullname"
                  trackBy="userId"
                  :taggable="false"
                  :multiple="true"
                  :hasClose="false"
                  :visibleTagCount="1"
                  :hasOptionMeta="true"
                  :metaRightComponent="DriverRegisteredIcon"
                  :showSelectionCount="true"
                  :max="30"
                  @update:fullObject="($event) => (fullObject.registeredDriver = $event)"
                />
              </div>
            </b-col>
            <b-col sm="12" md="3">
              <div class="mt-3">
                <FormulateInput
                  id="hullNo"
                  v-model="form.hullNo"
                  :placeholder="$t('global.object.hullNo')"
                  :label="$t('global.object.hullNo')"
                />
              </div>
            </b-col>

            <b-col sm="12">
              <div class="mt-3">
                <div class="form-check-right form-switch">
                  <input
                    id="SwitchCheckSizemd"
                    v-b-toggle.accordion-3
                    class="form-check-input ms-2"
                    type="checkbox"
                  />
                  <label class="" for="SwitchCheckSizemd">
                    {{ $t('global.object.otherInfo') }}
                  </label>
                </div>
              </div>
            </b-col>
          </b-row>

          <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
            <b-row v-if="form.fleetType">
              <b-col sm="12" md="3">
                <div class="my-3">
                  <b-form-group :label="`${$t('setting.list.fleetSetting.tonage')}`">
                    {{ fullObject.vehicleType.tonnage ? fullObject.vehicleType.tonnage : 0 }}
                  </b-form-group>
                </div>
              </b-col>

              <b-col sm="12" md="3">
                <div class="my-3">
                  <b-form-group label="Volume (CBM)">
                    {{ fullObject.vehicleType.volume ? fullObject.vehicleType.volume : 0 }}
                  </b-form-group>
                </div>
              </b-col>

              <b-col sm="12" md="3">
                <div class="my-3">
                  <b-form-group :label="$t('master.form.fleet.fuel')">
                    <span> {{ fullObject.vehicleType.fuelType?.name }} </span>
                  </b-form-group>
                </div>
              </b-col>

              <b-col sm="12" md="2">
                <div class="my-3">
                  <b-form-group :label="$t('master.form.fleet.transmission')">
                    <span v-if="fullObject.vehicleType.transmissionType === 'A'">{{
                      $t('master.form.fleet.otomatis')
                    }}</span>
                    <span v-if="fullObject.vehicleType.transmissionType === 'M'">{{
                      $t('master.form.fleet.manual')
                    }}</span>
                    <span v-if="fullObject.vehicleType.transmissionType === 'T'">{{
                      $t('master.form.fleet.triptonik')
                    }}</span>
                  </b-form-group>
                </div>
              </b-col>
            </b-row>
            <b-row v-if="form.fleetType">
              <b-col sm="12" md="3">
                <div class="my-3">
                  <b-form-group :label="$t('master.form.fleet.fuelEfficiency')">
                    {{
                      fullObject.vehicleType.fuelEfficiency
                        ? fullObject.vehicleType.fuelEfficiency
                        : 0
                    }}
                  </b-form-group>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12" md="3">
                <div class="mb-3">
                  <FormulateInput
                    id="odometer"
                    v-model.trim="form.odometer"
                    type="number"
                    :placeholder="`${$t('global.form.enter')} ${$t(
                      'master.list.fleet.odometer'
                    )} (Km)`"
                    :label="`${$t('master.list.fleet.odometer')} (Km)`"
                    validation="min:0"
                    :validation-messages="{
                      min: $t('global.alert.text.odometerLimit'),
                    }"
                  />
                </div>
              </b-col>
              <b-col sm="12" md="3">
                <div class="mb-3">
                  <FormulateInput
                    id="thermoType"
                    v-model="form.thermoType"
                    type="select-resourceful-v2"
                    :placeholder="`${$t('global.form.select')} ${$t(
                      'master.form.fleet.thermoType'
                    )}`"
                    :label="$t('master.form.fleet.thermoType')"
                    :optionsGetter="resourcefulQuery.thermoTypes"
                    :optionLabelFn="({ item }) => item.text"
                    :taggable="false"
                    :multiple="false"
                    trackBy="text"
                    :fullObject="fullObject.thermoType"
                    @update:fullObject="($event) => (fullObject.thermoType = $event)"
                  />
                </div>
              </b-col>
              <b-col sm="12" md="3">
                <div class="mb-3">
                  <FormulateInput
                    id="chassisNo"
                    v-model.trim="form.chassisNumber"
                    name="chassisNo"
                    :placeholder="`${$t('global.form.enter')} ${$t(
                      'master.form.fleet.chassisNumber'
                    )}`"
                    :label="$t('master.form.fleet.chassisNumber')"
                  />
                </div>
              </b-col>
              <b-col sm="12" md="3">
                <div class="mb-3">
                  <FormulateInput
                    id="machineNo"
                    v-model.trim="form.machineNumber"
                    :placeholder="`${$t('global.form.enter')} ${$t(
                      'master.form.fleet.engineNumber'
                    )}`"
                    :label="`${$t('master.form.fleet.engineNumber')}`"
                  />
                </div>
              </b-col>
              <b-col sm="12" md="3">
                <div class="mb-3">
                  <FormulateInput
                    id="carrosserie"
                    v-model.trim="form.carrosserie"
                    :placeholder="`${$t('global.form.enter')} ${$t('master.form.fleet.karoseri')}`"
                    :label="$t('master.form.fleet.karoseri')"
                  />
                </div>
              </b-col>
              <b-col sm="12" md="3">
                <div class="mb-3">
                  <FormulateInput
                    id="thirdPartyId"
                    v-model="form.thirdPartyId"
                    :placeholder="`${$t('global.form.enter')} ${$t(
                      'master.form.fleet.referenceId'
                    )}`"
                    :label="$t('master.form.fleet.referenceId')"
                  />
                </div>
              </b-col>
            </b-row>
          </b-collapse>
        </b-card>

        <h4 class="card-title">
          {{ $t('master.form.fleet.operationalInformation') }}
        </h4>

        <b-card>
          <b-row>
            <b-col sm="12" md="3">
              <div class="mb-3">
                <FormulateInput
                  v-if="hasFeatureVehicleDistrictMgm"
                  id="district"
                  v-model="form.district"
                  name="district"
                  type="value-help-v2"
                  :label="$t('master.form.address.district')"
                  :placeholder="`${$t('global.form.select')} ${$t('master.form.address.district')}`"
                  :modalTitle="`${$t('global.form.select')} ${$t('master.form.address.district')}`"
                  :listGetter="resourcefulQuery.districts"
                  :tableFields="districtFields"
                  displayedBy="name"
                  trackBy="id"
                  :multiple="true"
                  :fullObject="fullObject.district"
                  :headerFilterTopComponent="headerFilterTopComponent"
                  :canSelectAll="true"
                  @update:fullObject="($event) => (fullObject.district = $event)"
                  @update:header-filter-full-object="
                    (payload) => {
                      if (payload.filterName === 'province') {
                        this.fullObject.districtFilterProvince = payload.value
                      } else if (payload.filterName === 'city') {
                        this.fullObject.districtFilterCity = payload.value
                      }
                    }
                  "
                />
                <FormulateInput
                  id="vGroups"
                  v-model="form.vgroups"
                  name="vGroups"
                  type="value-help-v2"
                  :label="$t('global.object.fleetGroup')"
                  help="required"
                  :placeholder="`${$t('global.form.select')} ${$t('global.object.fleetGroup')}`"
                  :modalTitle="`${$t('global.form.select')} ${$t('global.object.fleetGroup')}`"
                  :listGetter="resourcefulQuery.vGroups"
                  :tableFields="vGroupFields"
                  validation="required"
                  :validation-messages="{
                    required: `${$t('global.object.fleetGroup')} ${$t(
                      'global.validation.required'
                    )}`,
                  }"
                  displayedBy="name"
                  trackBy="id"
                  :multiple="true"
                  :fullObject="fullObject.vgroup"
                  validation-behavior="live"
                  error-behavior="live"
                  @update:fullObject="($event) => (fullObject.vgroup = $event)"
                />
              </div>
            </b-col>
            <b-col sm="12" md="3">
              <FormulateInput
                id="fleetStatus"
                v-model="form.status"
                type="select-resourceful-v2"
                :placeholder="`${$t('global.form.select')} ${$t('master.list.fleet.status')}`"
                :label="$t('master.list.fleet.status')"
                :optionsGetter="resourcefulQuery.statusOption"
                :optionLabelFn="({ item }) => item.label"
                :taggable="false"
                :multiple="false"
                trackBy="key"
                :fullObject="fullObject.status"
                @update:fullObject="($event) => (fullObject.status = $event)"
              />
            </b-col>
            <b-col sm="12" md="3">
              <div class="mb-3">
                <FormulateInput
                  id="geofence"
                  v-model="form.geofence"
                  type="select-resourceful-v2"
                  :placeholder="`${$t('global.form.select')} ${$t('master.form.fleet.garage')}`"
                  :label="$t('master.form.fleet.garage')"
                  :optionsGetter="resourcefulQuery.geofences"
                  :optionLabelFn="({ item }) => item.fenceName"
                  trackBy="geofenceId"
                  :taggable="false"
                  :multiple="false"
                  :fullObject="fullObject.geofence"
                  @update:fullObject="($event) => (fullObject.geofence = $event)"
                />
              </div>
            </b-col>
            <b-col sm="12" md="3">
              <div class="mb-3">
                <FormulateInput
                  id="operationalNotes"
                  v-model="form.operationalNotes"
                  name="operationalNotes"
                  type="select-resourceful"
                  trackBy="text"
                  validation-behavior="live"
                  error-behavior="live"
                  :label="$t('master.form.fleet.operationalNotes')"
                  :placeholder="`${$t('global.form.select')} ${$t(
                    'master.form.fleet.operationalNotes'
                  )}`"
                  :optionsGetter="resourcefulQuery.operationalNotes"
                  :optionLabelFn="({ item }) => item.text"
                  :initialObject="fullObject.operationalNotes"
                  :multiple="true"
                  :taggable="true"
                />
              </div>
            </b-col>
          </b-row>
        </b-card>

        <h4 class="card-title">
          {{ $t('master.form.fleet.device') }}
        </h4>

        <b-card class="mc-card__setting mb-3">
          <b-tabs content-class="p-3 text-muted">
            <b-tab :title="$t('master.pelacak')" active>
              <b-row>
                <b-col>
                  <b-card
                    class="mc-card__setting mc-card__setting-plain mb-3"
                    :class="{
                      active: form.sourceMode == 'GPS' && hasAccess(['driver_app_tracker:read']),
                      'mc-card-device p-3': hasAccess(['driver_app_tracker:read']),
                    }"
                  >
                    <McRadioButton
                      v-if="hasAccess(['driver_app_tracker:read'])"
                      id="GPS"
                      key="GPS"
                      v-model="form.sourceMode"
                      :label="$t('master.form.fleet.usingTracker')"
                      name="sourceMode"
                      initialValue="GPS"
                    />
                    <b-row class="mt-3">
                      <b-col :class="hasAccess(['driver_app_tracker:read']) ? '' : 'col-3'">
                        <FormulateInput
                          v-model="form.device"
                          type="select-resourceful-v2"
                          :placeholder="`${$t('global.form.select')} ${$t(
                            'master.form.tracker.trackerId'
                          )}`"
                          :optionsGetter="resourcefulQuery.devices"
                          :optionLabelFn="({ item }) => item.identifier"
                          trackBy="imei"
                          :disabled="form.sourceMode == 'DriverApps'"
                          :taggable="false"
                          :multiple="false"
                          :fullObject="fullObject.device"
                          @update:fullObject="($event) => (fullObject.device = $event)"
                        >
                          <template #label>
                            <label class="teal-300">{{
                              $t('master.form.tracker.trackerId')
                            }}</label>
                          </template>
                        </FormulateInput>
                      </b-col>
                      <b-col>
                        <label class="teal-300">{{ 'IMEI' }}</label>
                        <div class="d-flex align-items-center mt-2">
                          {{ fullObject.device ? fullObject.device.imei : '-' }}
                        </div>
                      </b-col>
                      <b-col>
                        <label class="teal-300">{{ $t('master.form.tracker.phoneNo') }}</label>
                        <div class="d-flex align-items-center mt-2">
                          {{ fullObject.device ? fullObject.device.phoneNo : '-' }}
                        </div>
                      </b-col>
                    </b-row>
                  </b-card>
                </b-col>
                <b-col v-if="hasAccess(['driver_app_tracker:read'])">
                  <b-card
                    class="mc-card-device p-3"
                    :class="{
                      'bg-light': !fullObject.firstDriver?.email,
                      active: form.sourceMode == 'DriverApps',
                    }"
                  >
                    <McRadioButton
                      id="DriverApps"
                      key="DriverApps"
                      v-model="form.sourceMode"
                      :label="$t('master.form.fleet.usingApp')"
                      name="sourceMode"
                      initialValue="DriverApps"
                      :disabled="!fullObject.firstDriver?.email"
                    />
                    <b-row class="mt-3 mb-2">
                      <b-col>
                        <label class="teal-300">{{ $t('master.form.fleet.driverEmail') }}</label>
                        <div class="d-flex align-items-center mt-2">
                          {{ form.firstDriver ? fullObject.firstDriver.email : '-' }}
                        </div>
                      </b-col>
                    </b-row>
                  </b-card>
                </b-col>
              </b-row>
            </b-tab>

            <b-tab
              v-if="hasAccess(['z1o-ibeacon-md:read']) && $route.params?.id && hasSensorIbeacon"
              :title="$t('master.form.fleet.sensorIbeacon')"
              class="mc-card__setting--ibeacon"
              @click="getIbeacon()"
            >
              <b-row class="my-3">
                <b-col md="3">
                  <b-form-group class="mb-3 mt-1">
                    <template #label>
                      <div class="d-flex justify-content-between align-items-center">
                        <label>
                          {{ $t('master.form.fleet.scanningIbeacon') }}
                        </label>
                      </div>
                    </template>

                    <div class="d-flex">
                      <McRadioButton
                        id="ibeaconStatusActive"
                        key="ibeaconStatusActive"
                        v-model="ibeacon.status"
                        :label="$t('global.active')"
                        name="ibeaconStatus"
                        :initialValue="true"
                        class="me-3"
                      />
                      <McRadioButton
                        id="ibeaconStatusNonactive"
                        key="ibeaconStatusNonactive"
                        v-model="ibeacon.status"
                        :label="$t('global.nonActive2')"
                        name="ibeaconStatus"
                        :initialValue="false"
                      />
                    </div>
                  </b-form-group>
                </b-col>
                <b-col v-if="hasDataIbeacoon" md="9">
                  <div class="mc-card__setting--ibeacon-detail">
                    <b-row>
                      <b-col md="3">
                        <label>
                          {{ $t('master.list.ibeacon.ibeaconId') }}
                        </label>
                        <div v-if="ibeacon.id">
                          <a
                            class="fw-bold text-primary td__noellipsis clickable-field"
                            @click="
                              $router.push({
                                name: 'Master Ibeacon',
                              })
                            "
                          >
                            {{ ibeacon.id ?? '-' }}
                          </a>
                        </div>
                        <p v-else>
-
</p>
                      </b-col>
                      <b-col md="3">
                        <label>
                          {{ $t('master.list.ibeacon.ibeaconName') }}
                        </label>
                        <p>
                          {{ ibeacon.name ?? '-' }}
                        </p>
                      </b-col>
                      <b-col md="3">
                        <label>
                          {{ $t('master.list.ibeacon.batteryLevel') }}
                        </label>
                        <div class="battery-level-container">
                          <b-alert
                            v-if="ibeacon.battery"
                            :variant="getBatteryVariant(ibeacon.battery)"
                            show
                            class="mb-0 py-1 px-2 d-inline-block"
                          >
                            {{ ibeacon.battery }}%
                          </b-alert>
                          <span v-else>-</span>
                        </div>
                      </b-col>
                      <b-col md="3">
                        <label>
                          {{ $t('master.list.ibeacon.description') }}
                        </label>
                        <div>
                          <b-tooltip target="ibeacon.description" placement="auto">
                            {{ ibeacon.description }}
                          </b-tooltip>
                          <span id="ibeacon.description">
                            <p class="mc-card__setting--ibeacon-detail-description">
                              {{ ibeacon.description }}
                            </p>
                          </span>
                        </div>
                      </b-col>
                    </b-row>
                  </div>
                </b-col>
              </b-row>
            </b-tab>
          </b-tabs>
        </b-card>

        <div class="clearfix mb-3">
          <div class="float-start">
            <h4 class="card-title">
              {{ $t('master.form.fleet.documentPermit.listDocument') }}
            </h4>
          </div>

          <div class="float-end">
            <McButton
              v-if="selected.length"
              variant="secondary-red"
              class="mx-2"
              icon="icon-outline_trash"
              :text="$t('global.delete')"
              @click="toDelete"
            />
            <McButton
              v-if="tData && tData.length > 0"
              variant="primary"
              icon="icon-outline_plus"
              :text="$t('global.addField')"
              @click="addDocumentPermit"
            />
          </div>
        </div>

        <b-card>
          <div class="table-responsive my-3 border border-1">
            <b-table
              v-if="tData && tData.length > 0"
              small
              show-empty
              :empty-text="$t('global.emptyTable')"
              :empty-filtered-text="$t('global.emptyFilteredTable')"
              :fields="fields"
              :items="tData"
              primary-key="rowKey"
              responsive="sm"
              class="datatables mc-table-fleetdoc"
            >
              <template #head(check)>
                <div class="form-check">
                  <b-form-checkbox
                    v-model="allSelected"
                    :indeterminate="indeterminate"
                    @change="toggleAll"
                  />
                </div>
              </template>

              <template #cell(check)="data">
                <div class="form-check">
                  <b-form-checkbox
                    v-model="selectedModel[data.index]"
                    :value="true"
                    :unchecked-value="false"
                    @change="checkTable($event, data)"
                  />
                </div>
              </template>

              <template #cell(type)="data">	
                <b-form-group>
                  <multiselect
                    v-model="data.item.docType"
                    :placeholder="`${$t('global.form.select')} ${$t(
                      'master.form.fleet.documentPermit.name'
                    )}`"
                    :options="docTypeUnSelected"
                    openDirection="top"
                    :class="{
                      'is-invalid': $v.tData.$each[data.index].docType.$error,
                    }"
                  />
                  <div v-if="$v.tData.$each[data.index].docType.$error" class="invalid-feedback">
                    <span v-if="!$v.tData.$each[data.index].docType.required">
                      {{ $t('master.form.fleet.documentPermit.nameReq') }}
                    </span>
                  </div>
                </b-form-group>
              </template>

              <template #cell(number)="data">
                <b-form-input
                  v-model="data.item.docNumber"
                  :placeholder="`${$t('global.form.enter')} ${$t(
                    'master.form.fleet.documentPermit.number'
                  )}`"
                  trim
                />
              </template>

              <template #cell(expired)="data">
                <b-form-group>
                  <date-picker
                    v-model="data.item.validUntil"
                    format="DD MMM YYYY"
                    value-type="YYYY-MM-DD"
                    :placeholder="$t('master.form.fleet.documentPermit.expired')"
                    :class="{
                      'is-invalid': $v.tData.$each[data.index].validUntil.$error,
                    }"
                    :lang="datePickerLang"
                    @input="checkStatus(data.index)"
                  />
                  <div v-if="$v.tData.$each[data.index].validUntil.$error" class="invalid-feedback">
                    <span v-if="!$v.tData.$each[data.index].validUntil.required">
                      {{ $t('master.form.fleet.documentPermit.expiredReq') }}
                    </span>
                  </div>
                </b-form-group>
              </template>

              <template #cell(status)="data">
                <div>
                  <span
                    v-if="data.item.status === 'expired'"
                    class="mc-status mc-status--red"
                  >
                    {{ $t('master.form.fleet.documentPermit.expired') }}
                  </span>
                  <span
                    v-else-if="data.item.status === 'near'"
                    class="mc-status mc-status--yellow"
                  >
                    {{ $t('master.form.fleet.documentPermit.status.nearExpired') }}
                  </span>
                  <span
                    v-else-if="data.item.status === 'active'"
                    class="mc-status mc-status--green"
                  >
                    {{ $t('master.form.fleet.documentPermit.status.active') }}
                  </span>
                </div>
              </template>
            </b-table>

            <McEmptyState
              v-if="!tData || tData.length === 0"
              :title="$t('maintenance.nolist.noData')"
              :desc="$t('master.service.emptyState.desc')"
              class="mt-3"
              @buttonPrimaryAction="addDocumentPermit"
            />
          </div>
        </b-card>
      </FormulateForm>
    </b-skeleton-wrapper>
    <IntegrationLogHistoryModal
      v-if="hasAccessAll(['webhook-log-event-md:read', 'webhook-event-du1-mdv1:read'])"
      module="md-vehicle"
      :identifier="$route.params.id"
    />

    <div v-if="hasAccessCustomerContract">
      <h4 class="card-title">
        {{ $t('master.form.customer.contractList') }}
      </h4>

      <McTable
        v-show="isTableContractDataAvailable"
        withCard
        searchable
        stickyHeader
        :fields="contractFields"
        :apiClient="contractApiClient"
        :hasCheckbox="false"
        @available-change="handleDataAvailable"
      >
        <template #[`cell(number)`]="{ value, item }">
          <a class="text-primary" target="_blank" rel="noopener" @click="openContract(item.id)">
            {{ item.number }}
          </a>
        </template>

        <template #[`cell(status.name)`]="{ value, item }">
          <span
            v-if="item.status?.color"
            class="__status-dots"
            :style="{ backgroundColor: item.status.color }"
          ></span>
          <span style="color: #344264">{{ value }}</span>
        </template>

        <template #[`cell(effective_date)`]="{ value }">
          <template v-if="value">
            <div>{{ formatIndexDate(value).date }}</div>
            <div class="text-muted">
              {{ formatIndexDate(value).time }}
            </div>
          </template>
          <template v-else>
-
</template>
        </template>

        <template #[`cell(expired_date)`]="{ value }">
          <template v-if="value">
            <div>{{ formatIndexDate(value).date }}</div>
            <div class="text-muted">
              {{ formatIndexDate(value).time }}
            </div>
          </template>
          <template v-else>
-
</template>
        </template>
      </McTable>
      <b-card v-show="!isTableContractDataAvailable">
        <div class="empty-table-container">
          <img style="max-width: 220px" :src="illustrationPath" alt />
          <strong>{{ $t('maintenance.nolist.noData') }}</strong>
        </div>
      </b-card>
    </div>
  </Layout>
</template>

<style lang="scss">
.formulate-input .multiselect__tags {
  max-height: fit-content;
}

.formulate-input .multiselect__tags .multiselect__tags-wrap {
  padding: 10px 40px 10px 10px;
}

.__status-dots {
  display: inline-block;
  margin: auto;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  margin-right: 8px;
}
</style>
